import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { LoginForm } from "@/features/auth/components/LoginForm";
import { AppStoreBadges } from "@/features/auth/components/AppStoreBadges";
import { LoginPromoText } from "@/features/auth/components/LoginPromoText";
import { LoginFooter } from "@/features/auth/components/LoginFooter";
import { shouldShowWebLoginUI } from "@/utils/platform";
import { EWebAccessCheckStatus, useWebAccessCheck } from "@/features/auth/hooks/useWebAccessCheck";
import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { getQueryFromURL } from "@/utils/url";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

export const LoginPage: FC = () => {
  const showWebUI = shouldShowWebLoginUI();
  const learnerId = getQueryFromURL<{ learnerId?: string }>()?.learnerId ?? "";
  const checkStatus = useWebAccessCheck(learnerId);

  if (checkStatus !== EWebAccessCheckStatus.ALLOWED) return <LoadingScreen />;

  return (
    <Box
      sx={{
        mx: -2,
        mt: -2,
        ...(showWebUI && {
          display: "flex",
          flexDirection: "column",
          minHeight: "calc(100% + 16px)",
        }),
      }}
    >
      <LoginLogo />
      {showWebUI && (
        <Stack gap={1}>
          <AppStoreBadges />
          <LoginPromoText />
        </Stack>
      )}
      <Box sx={showWebUI ? { mt: 2 } : undefined}>
        <LoginForm />
      </Box>
      {showWebUI && <LoginFooter />}
    </Box>
  );
};
